import axios from 'axios';

export default {
  fetchCompany() {
    return axios.get('/company/showCurrent')
      .then(res => res);
  },
  fetchUser() {
    return axios.get('/user/showCurrent')
      .then(res => res);
  },
  saveUser(_, user) {
    const tempUserObject = user;
    tempUserObject.reseller = true;

    return axios.post('/user', tempUserObject);
  },
  getCompanyData(_, companyId) {
    return axios.get(`/company/show/${companyId}`);
  },
};
